import type { ProductDTO } from '../api/types';
import type { Product } from '../model/types';

export const mapProduct = (dto: ProductDTO): Product => {
  return {
    id: dto.id,
    name: dto.name,
  };
};
